export default __webpack_public_path__ + "static/media/user-disconnected.dbc9aa84.svg";